<template>
  <div class="selected-site-container h-100">
    <div class="header-container">
      <div class="close-details clickable" @click="onClose()">
        <div class="x">&times;</div>
      </div>
    </div>
    <field-container title="Selected Site" :parentContainer="true">
      <div class="site-details-container">
        <field-container title="">
          <overview :mappable="selected"></overview>
        </field-container>

        <field-container title="Create Data Entry">
          <data-entry-section :mappable="selected"></data-entry-section>
        </field-container>

        <field-container title="Request Details">
          <div class="request-info-text">
            <div>Name: {{ name }}</div>
            <div>Address: {{ address }}</div>
            <div>Phone{{ phoneNight ? ' (Day)' : '' }}: {{ phoneDay }}</div>
            <div v-if="phoneNight">Phone (Night): {{ phoneNight }}</div>
            <div>Comments:</div>
            <div class="comments">
              {{ comments }}
            </div>
          </div>
        </field-container>
      </div>
    </field-container>
  </div>
</template>

<script>
import DataEntrySection from './data-entry-section';
import FieldContainer from '../../../common/field-container';
import FieldNotesSection from './field-notes-section.vue';
import Overview from './overview';
import SiteHistorySection from './site-history-section.vue';
import SiteNotesSection from './site-notes-section.vue';
import SiteReminderSection from './site-reminder-section.vue';
import { toTitle } from '@/utils/strings';
import { standardDateStamp } from '@/utils/dates';

export default {
  components: {
    DataEntrySection,
    FieldContainer,
    FieldNotesSection,
    Overview,
    SiteHistorySection,
    SiteNotesSection,
    SiteReminderSection,
  },

  props: {
    selected: Object,
  },

  computed: {
    name() {
      const { contract } = this.selected;
      const { name } = contract;
      return toTitle(name);
    },
    address() {
      const { address } = this.selected;
      return toTitle(address);
    },
    phoneDay() {
      const { phoneDay } = this.selected;
      return phoneDay || 'N/A';
    },
    phoneNight() {
      const { phoneNight } = this.selected;
      return phoneNight;
    },
    comments() {
      const { notes } = this.selected;
      return notes || 'N/A';
    },
  },

  methods: {
    onClose() {
      const { dispatch } = this.$store;
      dispatch('selectMappable', null);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/variables';

.flex {
  display: flex;

  & .space-between {
    justify-content: space-between;
  }
}

.selected-site-container {
  margin-top: -1.8rem;
  height: 100%;
}

.site-details-container {
  margin-right: -1rem;
  margin-top: -1rem;
  overflow-x: hidden;
  overflow-y: auto;
  height: 739px;
}

.site-actions-text {
  font-family: Roboto;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.87);
}

.request-info-text {
  font-family: Roboto;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.87);

  & div {
    margin-bottom: 1.5rem;
  }
}

.requested-on {
  font-family: Roboto;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #757575;
  margin-bottom: 1rem;
}

.header-container {
  display: flex;
  float: right;
  justify-content: space-between;

  & .close-details {
    margin-top: 8px;
    position: relative;
    top: -4px;
    right: 10px;
    width: 11px;
    height: 11px;

    & .x {
      color: #000000;
      font-size: 24px;
      font-weight: 300;
      position: relative;
      bottom: 13px;
      right: 0.5px;
      height: 0;
      width: 0;
    }
  }
}

.comments {
  font-family: Roboto;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #757575;
  margin-top: -1rem;
}

.clickable {
  cursor: pointer;
}
</style>
